import { useNavigate, useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import type { ErrorComponentProps } from '@tanstack/react-router'

type InternalErrorProps = ErrorComponentProps

function InternalError({ error, reset }: InternalErrorProps) {
  const navigate = useNavigate()
  const router = useRouter()
  const { reset: resetQuery } = useQueryErrorResetBoundary()

  const handleBack = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (router.history.canGoBack()) {
      return router.history.back()
    }
    navigate({ to: '/' })
  }

  const handleReset = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    reset()
    resetQuery()
  }

  useEffect(() => {
    if (Sentry.isEnabled() && error) {
      Sentry.captureException(error)
    }
  }, [error])

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-4 text-center">
      <h1 className="text-3xl font-bold">500 - Internal Server Error</h1>
      <p className="text-lg text-gray-600">
        Something went wrong on our end. Please try again later.
      </p>
      <div className="flex gap-2">
        <button
          onClick={handleBack}
          className="rounded bg-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-600"
        >
          Go Back
        </button>
        <button
          onClick={handleReset}
          className="rounded bg-green-500 px-4 py-2 font-semibold text-white hover:bg-green-600"
        >
          Retry
        </button>
      </div>
    </div>
  )
}

export default InternalError
